import type { VideoContentObject } from 'models';
import { Card, CollapsibleCard, DocumentLineIcon, RichTextRenderer } from 'ui';
import { Translation } from 'features/translations';

type P = {
  videoContentObject: VideoContentObject;
};

const DescriptionCard = ({ videoContentObject }: P) => (
  <CollapsibleCard card={{ title: <Card.Title icon={<DocumentLineIcon />}>Description</Card.Title> }}>
    <RichTextRenderer data={videoContentObject.video.htmlContent} />
    <Translation id={videoContentObject.video.id} type="video" />
  </CollapsibleCard>
);

export default DescriptionCard;
